import React, { useState } from "react";
import { Link, Outlet } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

export default function Navr() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top shadow-sm">
        <div className="container">
          
          {/* BRAND */}
          <Link
            className="navbar-brand hero-title fw-bold"
            to="/"
            onClick={closeMenu}
          >
            Tillu Events
          </Link>

          {/* TOGGLER */}
          <button
            className="navbar-toggler"
            type="button"
            aria-expanded={isOpen}
            aria-label="Toggle navigation"
            onClick={toggleMenu}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* MENU */}
          <div
            className={`collapse navbar-collapse ${isOpen ? "show" : ""}`}
          >
            <ul className="navbar-nav ms-auto text-center gap-lg-3">
              
              <li className="nav-item">
                <Link className="nav-link" to="/" onClick={closeMenu}>
                  Home
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="/Services" onClick={closeMenu}>
                  Services
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="/Gallery" onClick={closeMenu}>
                  Gallery
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="/Contact" onClick={closeMenu}>
                  Contact
                </Link>
              </li>

              {/* CTA Button */}
              <li className="nav-item  mt-lg-0">
                <Link
                  className="btn mt-2 btn-outline-info rounded-pill px-4"
                  to="/Contact"
                  onClick={closeMenu}
                >
                  Book Now
                </Link>
              </li>

            </ul>
          </div>
        </div>
      </nav>

      {/* Page content */}
        <Outlet />
      
    </>
  );
}
